const MediaContentType = Object.freeze({
  IMAGE: "IMAGE",
  PDF: "PDF",
  KMZ: "KMZ"
});
export default MediaContentType;